import React, { useEffect, useRef, useState, useCallback } from "react";
import "./Users.css";
import { useNavigate } from "react-router-dom";
import { RoleId } from "./../../app/Enums/RoleId";
import {
  createAdminReq,
  getAllUserPaginated,
  DeactivateUser,
  ReactivateUser,
} from "./../../api/userApi/userManagementReq";

import DeleteModal from "./../../app/components/FeedbackModal/DeleteModal/DeleteModal";
import ReactivateModal from "./../../app/components/FeedbackModal/ReactivateModal/ReactivateModal";
import Pagination from "./../../app/components/Pagination/Pagination";
import { toast } from "react-toastify";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";
import {
  Ban,
  CheckCircle,
  PauseCircle,
  UserCheck,
  UserMinus,
  UserX,
} from "lucide-react";
import { validateForm } from "../../app/components/FormValidator/FormValidator";
function Users() {
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedUserEmail, setSelectedUserEmail] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isProcessing, setisProcessing] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState(
    JSON.parse(localStorage.getItem("RoleId")) === RoleId.SuperAdmin
      ? "admin"
      : "user",
  );

  const [formData, setFormData] = useState({
    userName: "",
    mobileNo: "",
    email: "",
    isActive: true,
    createdBy: RoleId.SuperAdmin,
  });

  const [formErrors, setFormErrors] = useState({
    userName: "",
    email: "",
    mobileNo: "",
  });

  const [userList, setUserList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const tableRef = useRef(null);

  // Debounce search term to avoid too many API calls
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPageNumber(1);
  };

  const openModalBox = () => {
    setOpenModal(true);
  };

  const closeModalBox = () => {
    setOpenModal(false);
    setFormErrors({
      userName: "",
      email: "",
      mobileNo: "",
    });

    setFormData({
      userName: "",
      mobileNo: "",
      email: "",
      isActive: true,
      createdBy: RoleId.SuperAdmin,
    });
  };

  const navigateDashboard = () => {
    navigate("/dashboard");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async () => {
    setisProcessing("Save");
    try {
      const { isValid, errors } = validateForm(formData);

      if (!isValid) {
        setFormErrors(errors);
        return;
      }
      const res = await createAdminReq(formData);
      console.log(res);

      if (!res.error) {
        const status = res.data?.result;
        const message = res.data?.message || "No message";

        if (
          status === 1 &&
          res.data?.error_value?.errorText === "SmtpException"
        ) {
          toast.error(
            "User created successfully. However, email could not be sent.",
          );
        } else if (status === 1) {
          toast.success(message);
          setFormErrors({
            userName: "",
            email: "",
            mobileNo: "",
          });
          setFormData({
            userName: "",
            mobileNo: "",
            email: "",
            isActive: true,
            createdBy: RoleId.SuperAdmin,
          });
          setOpenModal(false);
          fetchUsers();
        } else if (status === 3) {
          const fallback = "Email already registered";
          const errorMessage =
            res.data?.error_value?.errorText || res.message || fallback;
          toast.error(errorMessage);
        } else {
          toast.error(message);
        }
      } else {
        const fallback = "Failed to create user.";
        const errorMessage =
          res.data?.error_value?.errorText || res.message || fallback;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setisProcessing(null);
    }
  };

  const fetchUsers = useCallback(async () => {
    const callerRoleId = JSON.parse(localStorage.getItem("RoleId"));
    const data = {
      callerRoleId,
      pageNumber,
      pageSize,
      statusFilter: statusFilter,
      roleFilter: roleFilter,
      searchTerm: debouncedSearchTerm || "", // Use debounced search term
    };

    setIsLoading(true);
    try {
      const res = await getAllUserPaginated(data);

      console.log("API Response:", res.data);

      // Check different response structures
      let users = [];
      let total = 0;

      if (res?.data?.result_value) {
        users = res.data.result_value;
        total = res.data.totalRows || 0;
      } else if (res?.data?.Result_value) {
        users = res.data.Result_value;
        total = res.data.TotalRows || 0;
      } else if (res?.data?.data?.result_value) {
        users = res.data.data.result_value;
        total = res.data.data.totalRows || 0;
      } else if (Array.isArray(res?.data)) {
        users = res.data;
      }

      // Transform snake_case to camelCase if needed
      const transformedUsers = users.map((user) => ({
        user_Id: user.user_id || user.user_Id,
        user_Name: user.user_name || user.user_Name,
        email: user.email,
        phone_number: user.phone_number,
        role_Name: user.role_name || user.role_Name,
        is_Active:
          user.is_active !== undefined ? user.is_active : user.is_Active,
        status: user.status,
        createdDate: user.CreatedDate || user.createdDate,
      }));

      setUserList(transformedUsers);
      setTotalRows(total);

      // Reset to page 1 if no results on current page
      if (transformedUsers.length === 0 && pageNumber > 1) {
        setPageNumber(1);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch users");
    } finally {
      setIsLoading(false);
    }
  }, [pageNumber, pageSize, statusFilter, roleFilter, debouncedSearchTerm]);

  const confirmDeactivate = (userId, userName) => {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
    setShowDeleteModal(true);
  };

  const confirmReactivate = (userId, userName, email) => {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
    setSelectedUserEmail(email);
    setShowReactivateModal(true);
  };

  const handleDeactivateUser = async () => {
    try {
      const res = await DeactivateUser(selectedUserId);
      if (!res.error) {
        toast.success("User deactivated successfully");
        fetchUsers();
      } else {
        toast.error(`Failed to deactivate: ${res.message}`);
      }
    } catch (error) {
      console.error("Error deactivating user:", error);
      toast.error(error.errorMsg || "Something went wrong");
    } finally {
      setShowDeleteModal(false);
      setSelectedUserId(null);
      setSelectedUserName("");
    }
  };

  const handleReactivateUser = async () => {
    try {
      const res = await ReactivateUser({
        userId: selectedUserId,
        callerRoleId: isSuperAdmin ? RoleId.SuperAdmin : RoleId.Admin,
        email: selectedUserEmail,
      });

      if (!res.error) {
        toast.success(res.message || "User reactivated successfully");
        fetchUsers();
      } else {
        toast.error(res.message || res.errorMsg || "Failed to reactivate user");
      }
    } catch (error) {
      console.error("Error reactivating user:", error);
      toast.error(error.errorMsg || "Something went wrong");
    } finally {
      setShowReactivateModal(false);
      setSelectedUserId(null);
      setSelectedUserName("");
      setOpenModal(false);
    }
  };

  const resetFilters = () => {
    setSearchTerm("");
    setStatusFilter("all");
    setRoleFilter("admin");
  };

  useEffect(() => {
    const roleId = JSON.parse(localStorage.getItem("RoleId"));
    setIsSuperAdmin(roleId === RoleId.SuperAdmin);
    setIsAdmin(roleId === RoleId.Admin);
    if (roleId === RoleId.SuperAdmin && roleFilter === "admin") {
      setRoleFilter("admin");
    } else if (roleId === RoleId.Admin) {
      setRoleFilter("user");
    }
  }, [resetFilters]);

  const canShowActions =
    (isSuperAdmin && roleFilter === "admin") ||
    (isAdmin && roleFilter === "user");

  // Fetch users when any parameter changes
  useEffect(() => {
    if (isSuperAdmin || isAdmin) {
      fetchUsers();
    }
  }, [
    isSuperAdmin,
    isAdmin,
    pageNumber,
    pageSize,
    statusFilter,
    roleFilter,
    debouncedSearchTerm,
    fetchUsers,
  ]);

  // Reset page number when filters change
  useEffect(() => {
    if (pageNumber !== 1) {
      setPageNumber(1);
    }
  }, [statusFilter, roleFilter, debouncedSearchTerm]);

  if (!isSuperAdmin && !isAdmin) {
    return (
      <div className="no-access">
        <h3>You are not authorized to view this page.</h3>
      </div>
    );
  }

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-out-wraper">
          <div className="role-box">
            <h2>Users Management</h2>
            <div className="search-filter-section">
              <div className="form-wraper">
                <label>Search </label>
                <div className="search-box">
                  <i className="bi bi-search"></i>
                  <input
                    type="text"
                    placeholder="Search by name, email, or role..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  {searchTerm && (
                    <button
                      className="clear-search"
                      onClick={() => setSearchTerm("")}
                    >
                      <i className="bi bi-x"></i>
                    </button>
                  )}
                </div>
              </div>
              <div className="form-wraper">
                <label>All Status</label>
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="filter-select"
                >
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              {isSuperAdmin && (
                <div className="form-wraper">
                  <>
                    <label>Select Roles</label>
                    <select
                      value={roleFilter}
                      onChange={(e) => setRoleFilter(e.target.value)}
                      className="filter-select"
                    >
                      {/* <option value="all">All Roles</option> */}
                      <option value="admin">Admin</option>
                      <option value="user">User</option>
                    </select>
                  </>
                </div>
              )}
              <div className="d-flex align-items-center">
                {(searchTerm ||
                  statusFilter !== "all" ||
                  (isSuperAdmin && roleFilter !== "admin")) && (
                  <button
                    className="secondary_btn mr_10"
                    onClick={resetFilters}
                  >
                    Clear Filters
                  </button>
                )}
                {isSuperAdmin && (
                  <button
                    type="button"
                    className="primary_btn"
                    onClick={openModalBox}
                  >
                    Add Admin
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="main_widget">
            <div className="main_widget_body">
              <div className="table-responsive" ref={tableRef}>
                {userList.length === 0 ? (
                  <div className="no-results">
                    <p>No users found matching your criteria.</p>
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th className="sn_th">S. No</th>
                        <th className="name_th">Name</th>
                        <th className="email_th">Email</th>
                        {isSuperAdmin && <th className="phone_th">Role</th>}
                        {/* <th className="phone_th">Role</th> */}
                        <th className="status_th">Status</th>
                        {canShowActions && (
                          <th className="action_th">Action</th>
                        )}
                        {/* <th className="action_th">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {userList.map((user, index) => (
                        <tr
                          key={user.user_Id}
                          // className={!user.is_Active ? "inactive-user" : ""}
                        >
                          <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                          <td>{user.user_Name}</td>
                          <td>{user.email}</td>
                          {isSuperAdmin && <td>{user.role_Name}</td>}
                          <td>
                            <div
                              className="tooltip-wrapper"
                              style={{
                                "--bg-color": user.is_Active
                                  ? "#16a34a"
                                  : "#dc2626",
                              }}
                            >
                              {user.is_Active ? (
                                <CheckCircle className="icon icon-approved" />
                              ) : (
                                <Ban className="icon icon-deactivated" />
                              )}
                              <span className="tooltip-text">
                                {user.is_Active ? "Active" : "Inactive"}
                              </span>
                            </div>
                          </td>
                          {/* {isSuperAdmin && roleFilter === "admin" ?(
                          <td className="action_td">
                            <div className="action-buttons">
                              {!user.is_Active && roleFilter === "admin"? (
                                <button
                                  className="reactivate-btn"
                                  onClick={() =>
                                    confirmReactivate(
                                      user.user_Id,
                                      user.user_Name,
                                      user.email
                                    )
                                  }
                                  title="Reactivate User"
                                >
                                  <i className="bi bi-arrow-clockwise"></i>
                                  Restore User
                                </button>
                              ) : (
                                <>
                                  {isSuperAdmin && roleFilter === "admin" && (
                                    <button
                                      className="deactivate-btn"
                                      onClick={() =>
                                        confirmDeactivate(
                                          user.user_Id,
                                          user.user_Name
                                        )
                                      }
                                      title="Deactivate User"
                                    >
                                      <i className="bi bi-person-dash"></i>
                                      Deactivate User
                                    </button>
                                  )}

                                  {isAdmin &&
                                    (user.role_Name === "SuperAdmin" ||
                                      user.role_Name === "Admin") ? (
                                    <button
                                      className="deactivate-btn disabled"
                                      onClick={() =>
                                        toast.error(
                                          "Access Denied: You do not have permission to deactivate this user."
                                        )
                                      }
                                      title="No permission"
                                      disabled
                                    >
                                      <i className="bi bi-person-dash"></i>
                                      Deactivate User
                                    </button>
                                  ) : (
                                    isAdmin && (
                                      <button
                                        className="deactivate-btn"
                                        onClick={() =>
                                          confirmDeactivate(
                                            user.user_Id,
                                            user.user_Name
                                          )
                                        }
                                        title="Deactivate User"
                                      >
                                        <i className="bi bi-person-dash"></i>
                                        Deactivate User
                                      </button>
                                    )
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                           ) :

                           <td className="action_td">
                            <div className="action-buttons">
                              {!user.is_Active && roleFilter === "user"? (
                                <button
                                  className="reactivate-btn"
                                  onClick={() =>
                                    confirmReactivate(
                                      user.user_Id,
                                      user.user_Name,
                                      user.email
                                    )
                                  }
                                  title="Reactivate User"
                                >
                                  <i className="bi bi-arrow-clockwise"></i>
                                  Restore User
                                </button>
                              ) : (
                                <>
                                  {isAdmin && roleFilter === "user" && (
                                    <button
                                      className="deactivate-btn"
                                      onClick={() =>
                                        confirmDeactivate(
                                          user.user_Id,
                                          user.user_Name
                                        )
                                      }
                                      title="Deactivate User"
                                    >
                                      <i className="bi bi-person-dash"></i>
                                      Deactivate User
                                    </button>
                                  )}

                                  {isAdmin &&
                                    (user.role_Name === "SuperAdmin" ||
                                      user.role_Name === "Admin") ? (
                                    <button
                                      className="deactivate-btn disabled"
                                      onClick={() =>
                                        toast.error(
                                          "Access Denied: You do not have permission to deactivate this user."
                                        )
                                      }
                                      title="No permission"
                                      disabled
                                    >
                                      <i className="bi bi-person-dash"></i>
                                      Deactivate User
                                    </button>
                                  ) : (
                                    isAdmin && (
                                      <button
                                        className="deactivate-btn"
                                        onClick={() =>
                                          confirmDeactivate(
                                            user.user_Id,
                                            user.user_Name
                                          )
                                        }
                                        title="Deactivate User"
                                      >
                                        <i className="bi bi-person-dash"></i>
                                        Deactivate User
                                      </button>
                                    )
                                  )}
                                </>
                              )}
                            </div>
                          </td>

                          } */}
                          {canShowActions && (
                            <td>
                              <div className="action-buttons">
                                {!user.is_Active ? (
                                  <div
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#16a34a" }}
                                    onClick={() =>
                                      confirmReactivate(
                                        user.user_Id,
                                        user.user_Name,
                                        user.email,
                                      )
                                    }
                                  >
                                    <UserCheck className="icon icon-restore" />
                                    <span className="tooltip-text">
                                      Restore User
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#dc2626" }}
                                    onClick={() =>
                                      confirmDeactivate(
                                        user.user_Id,
                                        user.user_Name,
                                      )
                                    }
                                  >
                                    <UserX className="icon icon-deactivated" />
                                    <span className="tooltip-text">
                                      Inactive User
                                    </span>
                                  </div>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Pagination
        currentPage={pageNumber}
        totalPages={Math.ceil(totalRows / pageSize)}
        pageSize={pageSize}
        onPageChange={setPageNumber}
        onPageSizeChange={handlePageSizeChange}
      />

      {/* Form Modal */}
      <div className={`modal_overlay ${openModal ? "showModalBox" : ""}`}>
        <div className="modal">
          <div className="modal_header">
            <div className="modal_header_text">
              <h2>Add Admin </h2>
            </div>
            <div className="modal_cross_icon" onClick={closeModalBox}>
              <i className="bi bi-x-lg"></i>
            </div>
          </div>

          <div className="modal_body">
            <div className="form-wraper-bx">
              <label className="label">Username</label>
              <input
                type="text"
                name="userName"
                placeholder="Username"
                value={formData.userName}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            {formErrors.userName && (
              <p className="validation-error">{formErrors.userName}</p>
            )}

            <div className="form-wraper-bx">
              <label className="label">Mobile number(optional)</label>
              <input
                type="text"
                name="mobileNo"
                placeholder="Mobile Number(Optional)"
                value={formData.mobileNo}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            {formErrors.mobileNo && (
              <p className="validation-error">{formErrors.mobileNo}</p>
            )}

            <div className="form-wraper-bx">
              <label className="label">Email</label>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
              />
              {formErrors.email && (
                <p className="validation-error">{formErrors.email}</p>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="delete_approve_btn"
                onClick={handleSubmit}
                disabled={isProcessing === "Save"}
              >
                {isProcessing === "Save" ? (
                  <div className="spinner"></div>
                ) : (
                  "Save"
                )}
              </button>
              <button className="delete_reject_btn" onClick={closeModalBox}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        isOpen={showDeleteModal}
        onConfirm={handleDeactivateUser}
        onCancel={() => {
          setShowDeleteModal(false);
          setSelectedUserId(null);
          setSelectedUserName("");
        }}
        title="Deactivate User"
        message={`Are you sure you want to deactivate ${selectedUserName}?`}
      />

      <ReactivateModal
        isOpen={showReactivateModal}
        onConfirm={handleReactivateUser}
        isDeactivateModalOpen={isDeactivateModalOpen}
        onCancel={() => {
          setShowReactivateModal(false);
          setSelectedUserId(null);
          setSelectedUserName("");
        }}
        userEmail={selectedUserEmail}
        userName={selectedUserName}
      />
    </>
  );
}

export default Users;
